import _Config from "./Config.js";
import _Method from "./Methods.js";
import _BackendApi from "./APIs.js";

export const Config = new _Config();
export const Method = new _Method();
export const API = new _BackendApi();